export default "__VITE_ASSET__IlLOd7Qx__"